import React from 'react';
import { Link } from 'react-router-dom';
import { formatPrice, formatArea } from '../data/keszHazakModels';

const ModelCard = ({ model, className = '' }) => {
  return (
    <div className={`bg-white rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden group ${className}`}>
      {/* Kép */}
      <div className="relative aspect-video overflow-hidden">
        <img
          src={`/images/kesz-hazak/${model.hero_images[0]}`}
          alt={`${model.title} homlokzati nézet`}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
          loading="lazy"
          onError={(e) => {
            e.target.src = '/images/placeholder-house.jpg';
          }}
        />
        
        {/* Státusz badge */}
        {model.status_badge && (
          <div className="absolute top-4 left-4 bg-green-500 text-white text-xs font-semibold px-3 py-1 rounded-full">
            {model.status_badge}
          </div>
        )}
        
        {/* Ár badge */}
        <div className="absolute top-4 right-4 bg-[#e31937] text-white font-bold px-3 py-2 rounded-lg">
          <div className="text-sm">tól</div>
          <div className="text-lg leading-tight">{formatPrice(model.price_from_eur)}</div>
        </div>
      </div>

      {/* Tartalom */}
      <div className="p-6">
        <div className="mb-4">
          <h3 className="text-xl font-bold text-gray-900 mb-2 group-hover:text-[#e31937] transition-colors">
            {model.title}
          </h3>
          <p className="text-gray-600 text-sm mb-3">
            {model.short_tagline}
          </p>
          
          {/* Alapterület */}
          <div className="flex items-center text-gray-700 mb-3">
            <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 5a1 1 0 011-1h14a1 1 0 011 1v2a1 1 0 01-1 1H5a1 1 0 01-1-1V5zM4 13a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H5a1 1 0 01-1-1v-6zM16 13a1 1 0 011-1h2a1 1 0 011 1v6a1 1 0 01-1 1h-2a1 1 0 01-1-1v-6z" />
            </svg>
            <span className="text-sm font-medium">{formatArea(model.area_m2)}</span>
          </div>
        </div>

        {/* Highlights */}
        <div className="mb-4">
          <ul className="space-y-1">
            {model.highlights.slice(0, 3).map((highlight, index) => (
              <li key={index} className="flex items-center text-sm text-gray-600">
                <svg className="w-3 h-3 mr-2 text-green-500" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                </svg>
                {highlight}
              </li>
            ))}
          </ul>
        </div>

        {/* CTA gomb */}
        <Link
          to={`/kesz-hazak/${model.slug}`}
          className="block w-full bg-[#e31937] hover:bg-[#b40000] text-white font-semibold text-center py-3 px-4 rounded-lg transition-colors"
        >
          Megnézem a modellt
        </Link>
      </div>

      {/* Disclaimer */}
      <div className="px-6 pb-4">
        <p className="text-xs text-gray-500 text-center">
          Az ár tájékoztató jellegű, a végleges ár a választott műszaki tartalomtól és helyszíntől függ.
        </p>
      </div>
    </div>
  );
};

export default ModelCard;
